<template>
  <div>
    <div class="toolbar">
      <toolbar-right-menu-actions-item
        :right-menu-actions="rightMenuActions"
        :close-action-navigation-activity="closeActionNavigationActivity"
        :right-menu-actions-event="rightMenuActionsEvent"
        @onActionSelected="onRightMenuActionSelected"
        @resetRightMenuActionsEvent="rightMenuActionsEvent = false"
      >
      </toolbar-right-menu-actions-item>

      <div v-if="showCoBrandingLogoCompute || (lenderCobrandingUrl && showLenderCobrandingData)" class="co-branding-logo">
        <table class="co-branding-table">
          <tr>
            <td class="icon-td">
              <img
                v-if="showCoBrandingLogo"
                alt="EzCred"
                src="https://ezcred-public-docs.s3.ap-south-1.amazonaws.com/resources/app/ezcred_color_logo_with_name.png"
                class="img-responsive"
              />
            </td>
            <!--Marhcant co branding -->
            <td class="seprator-td" v-if="showCoBrandingLogoCompute">
              <div class="seprator"></div>
            </td>
            <td class="icon-td" v-if="showCoBrandingLogoCompute">
              <table>
                <tr>
                  <td>
                      <img
                        alt="CoBrand"
                        :src="coBrandingLogo"
                        class="img-responsive"
                        v-on:click="coBrandingButtonClicked"
                      />
                  </td>
                  <!-- <td v-if="coBrandingLogoTitle" >
                    <span class="co-branding-text"> <strong>{{coBrandingLogoTitle}}</strong> </span>
                  </td> -->
                </tr>
              </table>
            </td>
            <!--Marhcant co branding end-->
            <!-- Lender cobranding -->
            <td class="seprator-td" v-if="(lenderCobrandingUrl && showLenderCobrandingData)">
              <div class="seprator"></div>
            </td>
            <td class="icon-td">
              <img
                v-if="(lenderCobrandingUrl && showLenderCobrandingData)"
                alt="LenderBranding"
                :src="lenderCobrandingUrl"
                class="img-responsive"
              />
            </td>
            <!-- Lender cobranding end-->
          </tr>
        </table>
        <!-- Cobranding logo end-->
      </div>

      <wxc-minibar
        background-color="#0F8DE8"
        @wxcMinibarLeftButtonClicked="minibarLeftButtonClick"
        @wxcMinibarRightButtonClicked="minibarRightButtonClick"
        :use-default-return="false"
        :title="title"
        :showMoreVert="showRightMenu"
        :subTitle="subTitleComputed"
      >
      </wxc-minibar>
    </div>
  </div>
</template>

<script>
import WxcMinibar from "../../../weex-ui/packages/wxc-minibar/index";
import ToolbarRightMenuActionsItem from "./ToolBarRightMenuActionsItem";
import { ImageResourcesUtil } from "../../utils/ImageResourcesUtil";
import CoBrandingDataHolder from "../../data/model/CoBrandingDataHolder";
import LoanScopeDataHolder from "../../data/model/LoanScopeDataHolder";

export default {
  name: "ToolBar",
  components: { WxcMinibar, ToolbarRightMenuActionsItem },
  props: {
    title: {
      type: String,
      required: true,
      default: "Title",
    },
    subTitle: {
      type: String,
      required: false,
      default: "",
    },
    showSubTitle: {
      type: Boolean,
      required: false,
      default: true,
    },
    showRightMenu: {
      type: Boolean,
      default: true,
    },
    showCoBrandingLogo: {
      type: Boolean,
      default: true,
      required: false,
    },
    showLenderCobrandingData: {
      type: Boolean,
      default: true,
      required: false,
    },
    rightMenuActions: { type: Array },
    closeActionNavigationActivity: { type: String },
  },

  methods: {
    minibarLeftButtonClick() {},
    minibarRightButtonClick() {
      if (this.showRightMenu) {
        this.rightMenuActionsEvent = true;
      }
    },

    coBrandingButtonClicked() {
      if (this.showCoBrandingLogo) {
        
      }
    },

    onRightMenuActionSelected(action) {
      this.$emit("onActionSelected", action);
    },

    updateLenderCobrandingData() {
      if(LoanScopeDataHolder.showLenderCobranding()){
        this.lenderCobrandingUrl = LoanScopeDataHolder.getCobrandingIcon();
      }
    }
  },

  data: () => ({
    rightMenuActionsEvent: false,
    coBrandingLogo: "",
    coBrandingLogoTitle: "",
    lenderCobrandingUrl : ""
  }),

  created(){
    document.body.className = 'body-style';
    this.updateLenderCobrandingData();
  },

  computed: {
    rightMenuIcon() {
      return this.showRightMenu
        ? ImageResourcesUtil.getImageLink(ImageResourcesUtil.MENU_VERTICAL)
        : "";
    },

    leftMenuIcon() {
      return ImageResourcesUtil.getImageLink(
        ImageResourcesUtil.EZCRED_LOGO_WHITE
      );
    },

    showCoBrandingLogoCompute() {
      const coBrandingData = CoBrandingDataHolder.getCoBrandingData();
      if (!this.showCoBrandingLogo) {
        return false;
      } else if(Object.keys(coBrandingData).length == 0 &&
        coBrandingData.constructor === Object && CoBrandingDataHolder.getCoBrandingLogoUrl()) {
        return false;
      } else if(!CoBrandingDataHolder.getCoBrandingLogoUrl()){
        return false;
      } else {
        this.coBrandingLogo = CoBrandingDataHolder.getCoBrandingLogoUrl();
        this.coBrandingLogoTitle = CoBrandingDataHolder.getCoBrandingLogoText();
        return true;
      }
    },

    subTitleComputed(){
      if(this.showSubTitle)
        return this.subTitle ?  this.subTitle : LoanScopeDataHolder.getLoanAccountNumber();
      else
        return "";
    },

  },
};
</script>

<style scoped>
.toolbar {
  align-items: flex-start;
}
.co-branding-logo {
  background: #fff !important;
  height: 40px;
}
.co-branding-table {
  width: 100%;
}
.co-branding-text {
  margin-left: 10px;
  color: #000;
}
.seprator-td{
  width: 26px;
  vertical-align : baseline;
  text-align: -webkit-center !important;
  text-align: center;
}
.seprator {
  width: 1px;
  background: #1976d2;
  height: 40px;
}
.img-responsive {
  width: 70px;
  max-height: 31px;
}
.icon-td{
  text-align: -webkit-center !important;
  text-align: center;
}
</style>
